const settings = {
  env: {},
}

const envs = import.meta.env

const jsonEnvs = {
  VUE_APP_VERSION: 'undefined',
  VUE_APP_ENV: 'production',
  VUE_APP_API_URL: '',
  VUE_APP_DEFAULT_LANGUAGE: 'en',
  VUE_APP_ENV_NAME: 'grok',
  VUE_APP_YANDEX_CAPTCHA_ENABLED: '',
  VUE_APP_YANDEX_CAPTCHA_KEY: '',
  // VUE_APP_ENV_NAME: 'stater'
}

Object.entries(jsonEnvs).forEach(([key, defaultValue]) => {
  settings.env[key] = defaultValue
  if (envs[key] === `__${key}__`) {
    return
  }
  const localStorageValue = localStorage.getItem(key)
  if (localStorageValue) {
    try {
      const json = JSON.parse(localStorageValue)
      if (json !== undefined && json !== null) {
        settings.env[key] = json
      }
    } catch (e) {
      settings.env[key] = localStorageValue
    }
    return
  }
  try {
    const json = JSON.parse(envs[key])
    if (json !== undefined && json !== null) {
      settings.env[key] = json
    }
  } catch (e) {
    if (envs[key]) {
      settings.env[key] = envs[key]
    }
  }
})

export {settings}
